import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonHoverAnimation from 'components/ButtonHoverAnimation';
import TeasePicture from 'components/TeasePicture';
import AIMS_FLAVORS from 'lib/aimsFlavors';

const Promo3Card = (props) => {
  const {
    buttonTitle,
    buttonUrl,
    contentId,
    dek,
    headline,
    hideTeaseImage,
    teaseImage,
  } = props;
  const title = buttonTitle || i18next.t('MORE');

  return (
    <article
      data-contentid={contentId}
      className={classNames(
        'promo3Card',
        { 'promo3Card--has-image': !hideTeaseImage },
      )}
    >
      <h2 className="promo3Card__headline">
        {headline}
      </h2>
      <p className="promo3card__dek">
        {dek}
      </p>
      <ButtonHoverAnimation
        additionalClasses="promo3panel__button"
        title={title}
        size="small"
        type="link"
        url={buttonUrl}
      />
      {!hideTeaseImage && teaseImage && (
        <TeasePicture
          responsiveFlavors={{
            s: AIMS_FLAVORS.FOCAL_100x100,
            m: AIMS_FLAVORS.FOCAL_120x120,
            xl: AIMS_FLAVORS.FOCAL_170x170,
          }}
          url={teaseImage}
          hidePlaceholder
          className="promo3card__image"
        />
      )}
    </article>
  );
};

Promo3Card.propTypes = {
  buttonTitle: PropTypes.string,
  buttonUrl: PropTypes.string,
  contentId: PropTypes.string,
  dek: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  hideTeaseImage: PropTypes.bool,
  teaseImage: PropTypes.string,
};

Promo3Card.defaultProps = {
  buttonTitle: null,
  buttonUrl: null,
  contentId: null,
  hideTeaseImage: false,
  teaseImage: null,
};

export default Promo3Card;
